import { render, staticRenderFns } from "./popup-compte.vue?vue&type=template&id=3c127808&scoped=true"
import script from "./popup-compte.vue?vue&type=script&lang=js"
export * from "./popup-compte.vue?vue&type=script&lang=js"
import style0 from "./popup-compte.vue?vue&type=style&index=0&id=3c127808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c127808",
  null
  
)

export default component.exports